export async function action(method, path = "", body, resultFunction) {
    let requestOptions = {
        method: method
    };
    if (body) {
        requestOptions.headers = { 'Content-Type': 'application/json' };
        requestOptions.body = body;
    }
    await fetch(path, requestOptions)
    .then(async (response) => {
        if (!response.ok) require('../ModalDialogsTemplates').unknownErrorMessageDialog();
        else {
            if (resultFunction) resultFunction()
        }
    });
}